import { stateKeys } from '../constants';

export const selectSelectedRowKeys = (state) =>
  state[stateKeys.selectedRowKeys];

export const selectExpandedRowKeys = (state) =>
  state[stateKeys.expandedRowKeys];

export const selectFilterValue = (state) => state[stateKeys.filterInfo];

export const selectPage = (state) => state[stateKeys.page];
export const selectPageSize = (state) => state[stateKeys.pageSize];
export const selectTotalItems = (state) => state[stateKeys.totalItems];

export const selectPreparedDataIds = (state) =>
  state[stateKeys.preparedDataIdsSet];

export const selectAllCheckboxState = (state) => {
  const selected = state[stateKeys.selectedRowKeys];
  const dataIds = state[stateKeys.preparedDataIdsSet];

  if (!selected?.length) {
    return 'unchecked';
  }

  let selectedSize = 0;

  selected.forEach((id) => {
    if (dataIds.has(id)) {
      selectedSize++;
    }
  });

  if (selectedSize === 0) {
    return 'unchecked';
  }

  if (selectedSize === dataIds?.size) {
    return 'checked';
  }

  return 'indeterminate';
};

export const createIsSelectedRowSelector = (rowKey) => (state) => {
  return Boolean(state[stateKeys.selectedRowKeys]?.includes(rowKey));
};

export const createIsExpandedRowSelector = (rowKey) => (state) => {
  return Boolean(state[stateKeys.expandedRowKeys]?.includes(rowKey));
};

export const createFilterValueByNameSelector = (name) => (state) => {
  return state[stateKeys.filterInfo]?.[name];
};
